<template>
  <img
    v-show="showNow"
    class="gear__rotate--slow xer-rotate xer-h-15 xer-pointer-events-none"
    :src="getPictogramUrl('gear')"
    alt="Processing"
  />
</template>

<script>
import getPictogramUrl from '@/utils/get-pictogram-url';

export default {
  name: 'XerLoading',
  data() {
    return {
      showNow: false
    };
  },
  mounted() {
    this.showNow = true;
  },
  methods: {
    getPictogramUrl
  }
};
</script>

<style lang="scss" scoped>
.gear__rotate--slow {
  animation-duration: 3s;
}
</style>
